import p, { useRef as A, useEffect as b } from "react";
import { range as g } from "lodash";
import u from "mintel-icons";
import './Icon.css';const v = "#ccc", S = {
  Gray: v
}, _ = (e, s) => ({
  ...e,
  ...s
}), f = (e, s, t, i) => {
  !i || !t || g(t.length).forEach((r) => {
    e && t[r].hasAttribute("fill") && t[r].setAttribute("fill", i), s && t[r].hasAttribute("stroke") && t[r].setAttribute("stroke", i);
  });
}, E = (e, s, t, i, r) => {
  f(s, t, r?.querySelectorAll(".color"), e), f(
    s,
    t,
    r?.querySelectorAll(".alt_color"),
    i
  );
}, R = ({
  name: e = void 0,
  svg: s = void 0,
  size: t = "24px",
  color: i = S.Gray,
  alt_color: r = void 0,
  style: l = {},
  className: y = void 0,
  fillColor: o = !0,
  strokeColor: n = !0,
  ariaHidden: d = !1,
  testId: h = "icon"
}) => {
  const c = A(null);
  let a = s;
  return e && (a = u[e?.replace(/\.svg$/, "")] || u[e]), b(() => {
    e && E(i, o, n, r, c.current);
  }, [e, i, o, n, r, c]), /* @__PURE__ */ p.createElement(
    "span",
    {
      "aria-hidden": d,
      ref: c,
      style: _(l, {
        display: "inline-block",
        width: t,
        height: t
      }),
      className: y,
      dangerouslySetInnerHTML: { __html: a },
      "data-testid": h
    }
  );
};
export {
  R as I,
  S as i
};
